(function(){
    angular
        .module('app')
        .directive('swiperVideo', swiperVideo);

        swiperVideo.$inject = ['$timeout'];
        function swiperVideo($timeout){
            return {
              
              scope:{
                options:"="
              },
            controller:  ['$scope', '$element', function($scope, $element) {
                  var vm = this;
                  var options = {};
                  if($scope.options){
                    options = $scope.options;
                  }
                  
                  vm.videop = [];
                  // console.log($scope)
		                  $timeout(function(){
		                  	var swiperVideo = new Swiper($element[0] , {
                          allowTouchMove: false,
                          observer: true,
                          observeParents: true,
                          navigation: {
						          nextEl: $element.find(".swiper-button-next")[0],
						          prevEl: $element.find(".swiper-button-prev")[0],
						        },
						        on: {
						          slideChangeTransitionEnd: function () {
						            var previousSlide = this.slides[this.previousIndex];
						            if (!previousSlide) return;

						            // Pausar vídeos nativos
						            var videos = previousSlide.querySelectorAll('video');
						            videos.forEach(function(v) { v.pause(); });

						            // Pausar iframes de YouTube
						            var iframes = previousSlide.querySelectorAll('iframe');
						            iframes.forEach(function(f) {
						                f.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
						            });
						          },
						        },
						      });

		                  },250) 
                
                return vm;
            }]
          }
      }
})();